<nb-card>

  <nb-card-header>
    <div i18n="@@PublicFoods" class="title">Food Groups</div>

    <div class="actions">
      <nb-form-field class="search-field">
        <input nbInput shape="semi-round" fieldSize="small" #search class="search" type="text"
          (input)="onSearch(search.value)" i18n-placeholder="@@SearchThreeDots" placeholder="Search...">
        <nb-icon nbSuffix icon="search-outline" pack="eva"></nb-icon>
      </nb-form-field>
      <button nbButton type="submit" size="small"  class="add" (click)="AddCustomFood()">
        <nb-icon icon="plus"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <ng2-smart-table class="order-smart-table" [settings]="MyFoodTableSettings" [source]="CustomFoodSource"
      (add)="AddCustomFood" (edit)="onEdit($event)" (delete)="onDelete($event)">
    </ng2-smart-table>
  </nb-card-body>

  <nb-card-footer>
    <table style=" width: auto; float: right;">
      <tr>
        <td>
          <button i18n="@@AddNew" nbButton type="submit"  (click)="AddCustomFood()"
            class="btn-circle btn-xl btn-main btn-main">Add New</button>
        </td>
      </tr>
    </table>
  </nb-card-footer>

</nb-card>
